/* eslint-disable react/prop-types */
import React from 'react';
import { Card } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import './style.scss';

export default function HideComponent({ message, style }) {
  return (
    <Card className="access-denied-card" style={style || {}}>
      <div className="icon-container" aria-hidden="true">
        <FontAwesomeIcon icon={faLock} style={{ color: '#6b7280' }} className="lock-icon" />
      </div>
      <p className="access-denied-text" role="alert">
        {message || "You don't have access to view this content"}
      </p>
    </Card>
  );
}
